// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientEmrPtIndicator extends Model {
	// This is the name used as module name of the Vuex Store.
	static entity = 'PatientEmrPtIndicators'

	// List of all fields (schema) of the post model. `this.attr` is used
	// for the generic field type. The argument is the default value.
	static fields() {
		return {
			id: this.attr(null),
			pt_indicators_id: this.attr(null),
			pt_indicators_type: this.attr(null),
			pt_indicators_status: this.attr(null),
			datas: this.attr(null),
			pt_indicators_orderby: this.number(0)
		}
	}
}
